export default __webpack_public_path__ + "static/media/HorseshoeGrey.a593a213.svg";